import { render } from "./ManageTestRecords.vue?vue&type=template&id=90489126&scoped=true"
import script from "./ManageTestRecords.vue?vue&type=script&lang=js"
export * from "./ManageTestRecords.vue?vue&type=script&lang=js"

import "./ManageTestRecords.vue?vue&type=style&index=0&id=90489126&scoped=true&lang=css"
import "./ManageTestRecords.vue?vue&type=style&index=1&id=90489126&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/JEEducation.Management_STAGING/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90489126"]])

export default __exports__